import { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Typography } from '@mui/material';
import { CustomButton, FormTextField } from 'components/shared';
import { RadabankService } from 'utils/services';
import { IRadabankResetPasswordSetRequest } from 'utils/types';
import { resetRadabankPasswordSecretValidationSchema } from 'utils/validation';
import { RestoreRadabankPasswordStepProps } from '../../data';

export const RestoreRadabankPasswordSecretStep: FC<RestoreRadabankPasswordStepProps> = ({
	onSaveData,
	initialValues,
	onError,
	className = '',
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const methods = useForm({
		defaultValues: {
			secret: '',
		},
		mode: 'onTouched',
		resolver: yupResolver(resetRadabankPasswordSecretValidationSchema),
	});

	const {
		handleSubmit,
		formState: { isValid },
	} = methods;

	const onSubmit = async (values: Pick<IRadabankResetPasswordSetRequest, 'secret'>) => {
		try {
			setIsLoading(true);
			await RadabankService.resetPasswordSecret({ ...initialValues, ...values });
			onSaveData?.({ ...initialValues, ...values });
		} catch (error) {
			onError(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<FormProvider {...methods}>
			<form className={className} onSubmit={handleSubmit(onSubmit)}>
				<Typography>
					Введіть кодове слово, яке ви вводили при відкритті картки у додатку (якщо ви оформлювати картку в HOST -
					скоріше за все, ви вказували його англійськими літерами)
				</Typography>
				<FormTextField label="Кодове слово" name="secret" />
				<CustomButton
					type="submit"
					label="Продовжити"
					disabled={!isValid || !initialValues.sessionid}
					isLoading={isLoading}
					size="large"
				/>
			</form>
		</FormProvider>
	);
};
